<nav class="navbar navbar-expand navbar-light bg-light capitan-sub-nav pl-md-5">
<ul class="navbar-nav">
  <li class="nav-item">
    <a routerLink="./layout" routerLinkActive="active" class="nav-link" href="#">
      Profile Layout
    </a>
  </li>
  <li class="nav-item">
    <a routerLink="./custom-fields" routerLinkActive="active" class="nav-link" href="#">
      Custom Fields
    </a>
  </li>
</ul>
</nav>

<router-outlet></router-outlet>
